import { render } from "./pickAddressPopup.vue?vue&type=template&id=3587fe86"
import script from "./pickAddressPopup.vue?vue&type=script&lang=js"
export * from "./pickAddressPopup.vue?vue&type=script&lang=js"

import "./pickAddressPopup.vue?vue&type=style&index=0&id=3587fe86&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__